import endpoint from "../../config/endpoints";

export const holidayJson = {
    showSaveNextBtn: true,
    formPath: "/holiday-form",
    apiBaseURL: endpoint.holiday,
    changeExcel: endpoint.exportData,
    screenTitle: "Holiday",
    showAddButton: true,
    showPdfDownload: true,
    pdfFileName: "Holiday",
    showExcelDownload: true,
    excelFileName: "Holiday",
    formPathView: "/holiday-view",
    tableColumnsToFilter: [
        {
            columnDisplayName: "Holiday",
            columnKeyName: "holidayName",
            isChecked: true,
        },
        {
            columnDisplayName: "Day",
            columnKeyName: "day",
            isChecked: true,
        },
        {
            columnDisplayName: "Month",
            columnKeyName: "month",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Name",
            controlType: "textfield",
            placeHolder: "Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            dataKey: "name",
            inputType: "numberText",
            isMandatory: true,
            uniqueValidation: true,
        },
        {
            label: "Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "date",
            isMandatory: true,
        },
    ],
};
